import ReactTooltip from "react-tooltip";
import Header from "../Header";
import Lateral from "../Lateral";
import { FaCog, FaSearch } from "react-icons/fa";
import Division from "../Division";
import {Link} from "react-router-dom";
import { useEffect } from "react";

export default function BasePage({headerChildren, title, carrying, termSearch, qtdePage, typeSearch, children, URL}){
    return (
        <div>
            <Header />
            <Division />
            <Lateral />
            <ReactTooltip />

            {carrying && <div className="content">
                <div className="divCarrying">
                    <span>Carregando..</span>
                    <FaCog icon="spinner" className="spinner" />
                </div>
            </div>}
            
            {!carrying &&
                <div className="content">
                    <div className="title">
                        <span>{title}</span>
                        {headerChildren}
                        <Link to={`/${URL}/cadastrar`}>
                            <button className="buttonInsert" style={{fontWeight: '400'}}>
                                Cadastrar
                            </button>
                        </Link>
                        <select className='selectQtdeItens' value={qtdePage?.state} onChange={ (e) => qtdePage?.setState(e.target.value)}>
                            <option value="50">Itens por página</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="40">40</option>
                            <option value="50">50</option>
                        </select>
                        {typeSearch?.state !== undefined &&
                            <select className='selectQtdeItens' value={typeSearch?.state} onChange={(e) => typeSearch?.setState(e.target.value)}>
                                <option value="">Tipo de pesquisa</option>
                                <option value="S">Produto</option>
                                <option value="">Requisição</option>
                            </select>
                        }
                        <input className="inputSearch" type="text" value={termSearch?.state} onChange={(e) => termSearch?.setState(e.target.value)} placeholder="Search"/>
                        <FaSearch className="iconSearch" style={{color: '#001675' }} size={16}/>    
                    </div>
                    <div className="container">{children}</div>
                </div>
            }
        </div>
    )
}